import { Column, CellStyle as ReactGridCellStyle } from "@silevis/reactgrid";
import { Date, Worker, Tree, Company } from ".";
import { IData } from "@lhd/features/Salary/Provisions/hook";

export type OrgNodes = {
  id: number;
  company_id: number;
  name: string;
  org_type: string;
};

export interface SalaryPermissionConfigs {
  data?: {
    salary_edit?: (string | number)[];
    salary_delete?: (string | number)[];
    salary_view?: (string | number)[];
  };
}

export type Provision = Date & {
  id: number;
  company_id: string;
  year_cycle: string;
  month: number;
  integer: string;
  worker_id: string;
  division_id: string;
  branch_id: string;
  department_id: string;
  adjustment_detail: string;
  provision_type: "provision" | "arrangement" | "allowance" | "bonus";
  provision_item_id: string;
  account_type: string;
  unit_price: number;
  unit: string;
  number: number;
  amount: number;
  contract_amount: number;
  contractor: string;
  provision_amount: number;
  memo: string;
  created_at: string;
  updated_at: string;
  expense: number;
  achievement: number;
  deduction: number;
  worker: Worker;
  company: Company;
  department: Tree;
  branch: Tree;
  division: Tree;
  org_nodes: OrgNodes[];
};

export interface ProvisionItem {
  account_title: string;
  company_id: number;
  created_at: string;
  id: number;
  name: string;
  provision_type: string;
  updated_at: string;
}

export interface ColumnProps extends Column {
  type?: string;
  label?: string;
  editTable?: any;
}

// Type definitions
export interface DynamicRow extends IData {
  [key: string]: string | number | null | undefined | boolean;
}
export interface CellStyle extends ReactGridCellStyle {
  justifyContent?: "end";
  color?: string;
  backgroundColor: string;
}

export type CellType =
  | "text"
  | "number"
  | "date"
  | "numberCurrency"
  | "headerIcon";

export enum CellTypeEnum {
  TEXT = "text",
  NUMBER = "number",
  DATE = "date",
  NUMBER_CURRENCY = "numberCurrency",
  HEADER_ICON = "headerIcon",
}

export enum NonEditableField {
  INDEX = "index",
  YEAR_CYCLE = "year_cycle",
  AMOUNT = "amount",
  PROVISION_AMOUNT = "provision_amount",
}

export enum RowIndexLabel {
  TOTAL = "合計金",
}

export interface BaseGridCell {
  columnId: string | number;
  provisionId?: number | null;
  sort_index?: number | null;
  type: CellType;
  style?: CellStyle;
  nonEditable?: boolean;
  validator?: (value?: string | number | null) => boolean;
  value?: number | string | null;
  text?: string;
  date?: string | Date | null;
  format?: Intl.NumberFormat | Intl.DateTimeFormat;
  onClick?: (e: React.MouseEvent, value?: string | number | null) => void;
  icon?: React.ReactNode;
  idx?: number;
  required?: boolean;
  isFilter?: boolean;
  width?: number;
  additionalField?: string[];
  columnsActive?: string[];
  [key: string]:
    | string
    | number
    | boolean
    | null
    | undefined
    | ((...args: any[]) => any)
    | React.ReactNode
    | string[]
    | undefined;
}
export interface TextGridCell extends BaseGridCell {
  type: "text" | "numberCurrency" | "headerIcon";
  text?: string;
  onClick?: (e: React.MouseEvent, value?: string | number | null) => void;
  icon?: React.ReactNode;
  idx?: number;
  required?: boolean;
  isFilter?: boolean;
  width?: number;
  additionalField?: string[];
  columnsActive?: string[];
}
export interface NumberGridCell extends BaseGridCell {
  type: "number";
  value?: number;
  format?: Intl.NumberFormat;
}
export interface DateGridCell extends BaseGridCell {
  type: "date";
  format?: Intl.DateTimeFormat;
}

export type GridCell = TextGridCell | NumberGridCell | DateGridCell;

export interface RowData {
  rowId: string | number;
  height: number;
  reorderable?: boolean;
  cells: GridCell[];
}

export enum ProvisionTypeEnum {
  PROVISION = 1,
  ARRANGEMENT = 2,
  ALLOWANCE = 3,
  UNIT_PROVISION = 4,
}

export const ProvisionType = {
  PROVISION: "provision",
  ARRANGEMENT: "arrangement",
  ALLOWANCE: "allowance",
  UNIT_PROVISION: "unit_provision",
} as const;

export const DISPLAY_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;
